import React from "react";
import { Box, SvgIcon } from "@mui/material";
import { StriimTypography } from "@striim/striim-ui";
import { AIAssistantGradient } from "src/generic/icon/customIcons";
import { AI_AGENT_NAME } from "../../ai-constants";
import styles, { AnimatedIconContainer, PulsingIconWrapper, LoadingDot } from "./ai-loading-screen.styles";

interface AILoadingScreenProps {
    message?: string;
    subMessage?: string;
}

const AILoadingScreen: React.FC<AILoadingScreenProps> = ({
    message = `Setting up ${AI_AGENT_NAME}`,
    subMessage = "This may take a moment…"
}) => (
    <Box sx={styles.root}>
        <AnimatedIconContainer>
            <PulsingIconWrapper>
                <SvgIcon component={AIAssistantGradient as React.ElementType} sx={{ width: 80, height: 80 }} />
            </PulsingIconWrapper>
        </AnimatedIconContainer>

        <Box sx={styles.textBlock}>
            <StriimTypography sx={styles.headlineText} data-test-id="set-up-message-box">
                {message}
            </StriimTypography>
            <StriimTypography sx={styles.subtitleText}>{subMessage}</StriimTypography>
        </Box>

        <Box sx={styles.dotsRow}>
            <LoadingDot delay="0s" />
            <LoadingDot delay="0.25s" />
            <LoadingDot delay="0.5s" />
        </Box>
    </Box>
);

export default AILoadingScreen;
